const mobileBreakpoint = 1160;

module.exports = {
	mobileBreakpoint
};